export default "__VITE_ASSET__Ct6Hq$vN__"